<template>
    <span v-if="podeEditar" class="ml-2">
        <i
            class="fa fa-edit text-primary icon-button"
            title="Editar Natureza Orçamentária"
            @click.stop="abrirModal()"
        ></i>
        <b-modal
            v-model="mostrarModal"
            title="Editar Natureza Orçamentária"
            @show="carregarDados()"
        >
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>

            <b-form-group>
                <label class="required">Natureza Orçamentária</label>
                <b-form-select
                    :options="orcamentosFormatados"
                    v-model="orcamentoSelecionado"
                    text-field="codigoDescricao"
                    value-field="codigo"
                    :state="$v.orcamentoSelecionado.$error ? false : null"
                    @input="$v.orcamentoSelecionado.$touch()"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Selecione...
                        </b-form-select-option>
                    </template>
                </b-form-select>
                <b-form-invalid-feedback>Natureza Orçamentária é obrigatória</b-form-invalid-feedback>
            </b-form-group>

            <template #modal-footer>
                <b-button variant="secondary" @click="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid || salvando"
                    @click="confirmarSalvar()"
                >
                    {{ salvando ? 'Salvando...' : 'Salvar' }}
                </b-button>
            </template>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from '../ContratosServicos'
import ContratosRMServicos from '../../rm/ContratosRMServicos'

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        contrato: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarModal: false,
            orcamentos: [],
            orcamentoSelecionado: null,
            erros: [],
            salvando: false
        }
    },

    computed: {
        podeEditar() {
            return this.$temAcessoView('CONT-ELAB-01')
        },
        orcamentosFormatados() {
            return this.orcamentos
                .map(o => ({
                    ...o,
                    codigoDescricao: `${o.codigo} - ${o.descricao}`
                }))
                .sort((a, b) => a.descricao.localeCompare(b.descricao))
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.resetForm()
        },

        resetForm() {
            this.orcamentoSelecionado = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        carregarDados() {
            // Preencher com valor atual
            this.orcamentoSelecionado = this.item.codOrcamento

            // Carregar lista de orçamentos
            if (this.orcamentos.length === 0) {
                var dadosRM = this.contrato.dadosContratoRM
                var naturezaContrato = (dadosRM && dadosRM.naturezaContratoRMDto && dadosRM.naturezaContratoRMDto.codigo) || '2'
                ContratosRMServicos.obterDadosNovoItem(naturezaContrato).then((response) => {
                    if (response && response.success) {
                        this.orcamentos = response.data.orcamentoRMDto || []
                    }
                })
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Natureza Orçamentária',
                html: `Confirma a alteração da natureza orçamentária do item Nº <b>${this.item.ordem || this.item.nuOrdemItem}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            const orcamento = this.orcamentos.find(o => o.codigo === this.orcamentoSelecionado)

            if (!orcamento) {
                this.erros = ['Selecione uma natureza orçamentária válida']
                return
            }

            this.salvando = true
            this.$store.dispatch('addRequest')

            const dto = {
                codigo: orcamento.codigo,
                descricao: orcamento.descricao
            }

            ContratosServicos.atualizarOrcamentoItem(
                this.contrato.idContrato,
                this.item.itemContratoId,
                dto
            ).then((response) => {
                if (response && response.success) {
                    this.$toast.success(
                        'Natureza orçamentária atualizada com sucesso!',
                        'OK',
                        this.$toastConfig.success
                    )
                    this.$emit('atualizado', {
                        codOrcamento: orcamento.codigo,
                        descOrcamento: orcamento.descricao
                    })
                    this.fecharModal()
                } else {
                    this.erros = response.errors || ['Erro ao atualizar']
                }
                this.salvando = false
                this.$store.dispatch('removeRequest')
            }).catch(() => {
                this.erros = ['Erro ao atualizar natureza orçamentária']
                this.salvando = false
                this.$store.dispatch('removeRequest')
            })
        }
    },

    validations: {
        orcamentoSelecionado: {
            required
        }
    }
}
</script>

<style scoped>
.icon-button {
    cursor: pointer;
}
.icon-button:hover {
    opacity: 0.7;
}
</style>
